import { useState, useEffect } from 'react';
import BlogWin from '../Components/BlogWin';
import quotes from '../quotes.json';

let bodyStyle = {
    backgroundImage: `url(/doujinarchive/img/windowbg.jpg)`,
    backgroundRepeat: `no-repeat`
};

export default function Blog(props) {
    return(
        <div>
            <div className="window">
            <div className="window-title">
                <img alt="window icon" src={`/doujinarchive/ico/AYUFUSI.png`} className="window-icon"/>
                {quotes[Math.floor(Math.random() * quotes.length)]}
            </div>
            <div className="window-body" style={bodyStyle}>
                <table className="header-table">
                    <tr className="header-row">
                        <td>
                            <img alt="cover art" className="cover-art" src={`/doujinarchive/img/Welcome.png`}/>
                        </td>
                        <td className="game-info">
                            <h2>Research and Translation</h2>
                            <h6 className="maker">Learning is fun, 2025</h6>
                            <p className="description">Welcome to my research and translation blog. Here, you'll find posts about whatever piques my interest. I may occasionally even upload translation patches.</p>
                            <p>Click on a post's image to copy its permalink.</p>
                            <p>日本のゲームは人生が大きく変わった</p>
                        </td>
                    </tr>
                </table>
                <div className="controls">
                    <a href="http://hoshikawa-aru.com"><button>Aru</button></a>
                    <a href="https://bigbadboyyo.neocities.org"><button>Frank</button></a>
                    <a href="#"><button onClick={() => {props.chng('Archive')}}>Archive</button></a>
                </div>
            </div>
        </div>

        {props.posts.map((game, idx) => {    
            return(
                <BlogWin game={game} pn={props.posts.length - idx - 1}/>
            );
        })}
        </div>
    );
}